// extracted by mini-css-extract-plugin
module.exports = {"AppLink":"Country_AppLink__3JXpz","card":"Country_card__37TbY","title":"Country_title__p6O63"};